/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    content: string;
    ref_type: string;
    ref_id: number;
}
interface IOutput {
    top_section_id: number;
}

export const saveMultimedia = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.SAVE_MULTIMEDIA, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
